module.exports = __webpack_public_path__ + "img/fundermax-slider-1.97952268.jpg";